// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/audit.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { TaskAudit } from "./audit";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { TaskAuditListResponse } from "./audit";
import type { TaskAuditListRequest } from "./audit";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.task.v1.TaskAudit
 */
export interface ITaskAuditClient {
    /**
     * @generated from protobuf rpc: List(c1.api.task.v1.TaskAuditListRequest) returns (c1.api.task.v1.TaskAuditListResponse);
     */
    list(input: TaskAuditListRequest, options?: RpcOptions): UnaryCall<TaskAuditListRequest, TaskAuditListResponse>;
}
/**
 * @generated from protobuf service c1.api.task.v1.TaskAudit
 */
export class TaskAuditClient implements ITaskAuditClient, ServiceInfo {
    typeName = TaskAudit.typeName;
    methods = TaskAudit.methods;
    options = TaskAudit.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List(c1.api.task.v1.TaskAuditListRequest) returns (c1.api.task.v1.TaskAuditListResponse);
     */
    list(input: TaskAuditListRequest, options?: RpcOptions): UnaryCall<TaskAuditListRequest, TaskAuditListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskAuditListRequest, TaskAuditListResponse>("unary", this._transport, method, opt, input);
    }
}
